export default __webpack_public_path__ + "static/kb_2_11-5cd65c44b28558feb2f3e99b66b5829a.jpg";